import { CardImage } from "components/Basket/components/Cards/CardImage"
import { MembershipDescription } from "components/Basket/components/Cards/Membership/MembershipDescription"
import { MembershipPricing } from "components/Basket/components/Cards/Membership/MembershipPricing"

import type { ProductListVariants } from "components/BasketLists/ProductList/ProductList"

import React from "react"
import type { BasketPricingType, ItemType, Maybe } from "types"
import {
  container,
  imageWrapper,
  priceWrapper,
} from "./SimpleMembershipCard.css"

type Props = {
  item: ItemType
  variant?: ProductListVariants
  pricing: Maybe<BasketPricingType> | undefined
  imageUrl: string
}

export const SimpleMembershipCard: React.FC<Props> = ({
  item,
  pricing,
  imageUrl,
}) => (
  <div data-testid="membership-card" className={container}>
    <div>
      <CardImage
        item={item}
        src={imageUrl}
        alt={item?.membership?.visual?.altTag}
        imgHeight="90px"
      />
    </div>
    <div className={imageWrapper}>
      <MembershipDescription item={item} />
    </div>
    <div className={priceWrapper}>
      {pricing && <MembershipPricing item={item} pricing={pricing} />}
    </div>
  </div>
)
